<template>
  <div>
    <h2 class="ViewHeading">Water Management Reports</h2>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card no-body>
              <b-tabs card>
                <b-tab title="WM Report1" active>
                  <b-card>
                    <b-row
                      ><b-col>
                        <h4>Report Number 1</h4>
                      </b-col>
                      <b-col></b-col>
                      <b-col class="text-right"
                        ><p>
                          All times are in
                          <a
                            href="https://www.google.com/search?q=utc+time+zone+now&rlz=1C1ONGR_en-GBGB988GB988&oq=utc+time+zone+now&aqs=chrome..69i57j0i22i30l9.3553j0j4&sourceid=chrome&ie=UTF-8"
                            target="_blank"
                            >UTC</a
                          >
                          time zone
                        </p></b-col
                      ></b-row
                    >
                    <b-row>
                      <b-col>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          v-b-toggle.collapse-filters
                          >Filters</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row
                      ><b-col><br /></b-col
                    ></b-row>
                    <b-collapse id="collapse-filters" class="mt-2">
                      <b-card>
                        Filters1
                      </b-card>
                    </b-collapse>
                    <b-row
                      ><b-col><br /></b-col
                    ></b-row>
                  </b-card>
                </b-tab>
                <b-tab title="WM Report2" lazy>
                  <b-card>
                    <b-row
                      ><b-col>
                        <h4>Report Number 2</h4>
                      </b-col>
                      <b-col></b-col>
                      <b-col class="text-right"
                        ><p>
                          All times are in
                          <a
                            href="https://www.google.com/search?q=utc+time+zone+now&rlz=1C1ONGR_en-GBGB988GB988&oq=utc+time+zone+now&aqs=chrome..69i57j0i22i30l9.3553j0j4&sourceid=chrome&ie=UTF-8"
                            target="_blank"
                            >UTC</a
                          >
                          time zone
                        </p></b-col
                      ></b-row
                    >
                    <b-row>
                      <b-col>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          v-b-toggle.collapse-filters1
                          >Filters</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row
                      ><b-col><br /></b-col
                    ></b-row>
                    <b-collapse id="collapse-filters1" class="mt-2">
                      <b-card>
                        Filters2
                      </b-card>
                    </b-collapse>
                    <b-row
                      ><b-col><br /></b-col
                    ></b-row>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { singleUpload, directDownloadByKey } from "@/Services/aws.js";
import { delay } from "q";

export default {
  computed: {},
  components: {},

  data() {
    return {
      file: "",
      DeviceID: "123456789",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/attachments";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LoadAll",
      RequestVariable: this.DeviceID,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        response;
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      });
  },

  methods: {
    handleFileUpload() {
      this.file = event.target.files[0];
    },
    submitFile() {
      this.isExist();
      if (this.file == "") {
        alert("Please select a file to upload");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.size > 2000000) {
        alert("file selected is too large, maximum file size is 2mb");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.duplicatefile == true) {
        alert(
          "File with this name already exists, uploading will overwrite current file. Please delete existing file or change name of file to be uploaded."
        );
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      } else {
        this.uploadFile(this.file);
      }
    },

    isExist: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][3] == this.file.name) {
          this.duplicatefile = true;
          return true;
        }
      }
      this.duplicatefile = false;
      return false;
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    async uploadFile() {
      this.showOverlay = true;
      await delay(5000);
      const result = await singleUpload(
        this.file,
        this.DeviceID + "/" + this.Folder // folder of the file, you should change it to your variable or a string
      );
      if (result.status === 200) {
        this.showOverlay = false;
        alert("File upload successful");
        this.filePath = result.fullPath;
        this.submitFileToDB(this.file.name, this.filePath);
        this.file = "";
        document.getElementById("file-upload").value = null;
      } else {
        alert("Upload Failed");
      }
      return {
        abort: () => {},
      };
    },
    //async onRemoveFile(event) {
    //let url = "attachments" + '/' + event.file.name // event.file.name has only the name after the slash / so the actual filename
    //const res = await deleteObjectByKey(url)
    // if (
    //  res.$response.httpResponse.statusCode >= 200 &&
    //  res.$response.httpResponse.statusCode < 300
    // ){
    // here remove data from database too
    //  }
    // },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.DeviceID,
            FileName: FileSave,
            FileURL: FileLocation,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.refreshTable();
        });
    },

    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    async DownloadAttachment(filekey) {
      let attachment = this.DeviceID + "/attachments/" + filekey;
      const res = await directDownloadByKey(attachment);

      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTLM element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filekey); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
      alert("file download complete");
      this.$refs["DeviceAttachModal"].hide();
      this.refreshTable();
    },
    DeleteAttachment(delvar1) {
      this.DeleteUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Delete",
        RequestVariable: delvar1,
        DataDict: [
          {
            ClearedURN: this.DeleteUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.$refs["DeviceAttachModal"].hide();
          this.refreshTable();
        });
    },
    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },
    refreshTable() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LoadAll",
        RequestVariable: this.DeviceID,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
